'use client';

import React, { useEffect, useMemo, useRef, useState } from 'react';

import { useIsMobile } from '@/hooks/useIsMobile';

import type { FlatPackagesProps } from '../../types';
import CategoryPackages from './CategoryPackages';

export { useIsMobile } from '@/hooks/useIsMobile';

export default function Packages({
  data = [],
  labels,
  onEnquire = (): void => {},
  onBook,
}: FlatPackagesProps): React.ReactElement {
  const isMobile = useIsMobile();
  const totalCategories = data.length;
  const didScrollRef = useRef(false);

  const [userTouchedCats, setUserTouchedCats] = useState(false);

  const visibleCount = userTouchedCats
    ? totalCategories
    : Math.min(isMobile ? 2 : 3, totalCategories);

  useEffect((): void => {
    const hash = window.location.hash.slice(1);
    if (!hash) return;
    setUserTouchedCats(true);
    if (didScrollRef.current) return;
    didScrollRef.current = true;
    const element = document.getElementById(hash);
    if (element) element.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }, []);

  const visibleList = useMemo(
    () => data.slice(0, visibleCount),
    [data, visibleCount],
  );

  const handleLoadMoreCategories = (): void => setUserTouchedCats(true);

  const basePkgCount = isMobile ? 2 : 3;

  return (
    <section className="content-wrapper font-regular mx-auto px-0 py-8">
      {visibleList.map((category, ci) => (
        <CategoryPackages
          key={category?.slug || `cat-${ci}`}
          category={category}
          ci={ci}
          isMobile={isMobile}
          basePkgCount={basePkgCount}
          labels={labels}
          isLast={ci === visibleList.length - 1}
          onEnquire={onEnquire}
          onBook={onBook}
        />
      ))}

      {totalCategories > visibleCount && (
        <div className="mt-12 flex justify-center">
          <button
            onClick={handleLoadMoreCategories}
            className="border-theme-primary hover:text-theme-primary bg-theme-primary flex cursor-pointer items-center gap-2 rounded-sm border px-5 py-2 text-base font-bold text-white hover:bg-white"
          >
            Load More
          </button>
        </div>
      )}
    </section>
  );
}
